import type { ArtifactEntry } from "../stores/artifact-store"
import type { CanvasVersion } from "@/components/canvas-editor/version-history-dropdown"
import type { OpenCanvasPayload } from "@/features/canvas/stores/canvas-store"

import { openCanvasInSidebar } from "@/features/canvas/utils/canvas-sidebar"

import { useArtifactStore } from "../stores/artifact-store"

export function mapArtifactVersions(entry: ArtifactEntry): CanvasVersion[] {
  return entry.versions.map((v, index) => ({
    version: index + 1,
    content: v.content,
    timestamp: v.timestamp,
    is_ai_edit: true,
    ai_edit_preview: undefined,
  }))
}

/**
 * Builds the OpenCanvasPayload for live-syncing artifact content during streaming.
 * Ensures disablePersistence: true to prevent autosave of in-memory artifacts.
 */
export function buildArtifactCanvasSyncPayload(
  entry: ArtifactEntry,
  latestContent: string
): OpenCanvasPayload {
  return {
    title: entry.title,
    content: latestContent,
    activeDocumentCanEdit: true,
    versions: mapArtifactVersions(entry),
    messageId: entry.identifier,
    // Artifacts are in-memory only — they have no backing server resource, so
    // autosave must be disabled to prevent 404 errors from updateMessageApi.
    disablePersistence: true,
    sessionId: entry.sessionId,
    sessionFilenames: entry.sessionFilenames ?? [],
  }
}

export function openArtifactCanvas(entry: ArtifactEntry): void {
  useArtifactStore.getState().setOpenArtifactId(entry.identifier)
  openCanvasInSidebar(
    {
      title: entry.title,
      content: entry.versions.at(-1)?.content ?? "",
      activeDocumentCanEdit: true,
      versions: mapArtifactVersions(entry),
      // Use identifier as a pseudo-messageId so the canvas pane's entityId is
      // non-null, which enables the loadRevision-based live-sync path.
      messageId: entry.identifier,
      // Artifacts are in-memory only — they have no backing server resource, so
      // autosave must be disabled to prevent 404 errors from updateMessageApi.
      disablePersistence: true,
      sessionId: entry.sessionId,
      sessionFilenames: entry.sessionFilenames ?? [],
    },
    { title: entry.title }
  )
}
